import React from "react";
// @ts-expect-error: ignoring as it is existing js file
import InputMask from "react-input-mask";
import { Grid, TextField, GridProps, TextFieldProps } from "@mui/material";

interface FormDateInputProps extends Omit<TextFieldProps, "name" | "value" | "onChange" | "onBlur" | "error"> {
  fieldName: string;
  label: string;
  value?: string | number;
  error?: boolean | string; // MUI TextField expects boolean for error prop
  helperText?: string | boolean; // Add helperText for error messages
  disabled?: boolean;
  onChange: (value: string, fieldName: string) => void;
  onBlur: (fieldName: string, value: string) => void;
  gridProps?: GridProps;
}

const FormDateInput: React.FC<FormDateInputProps> = ({
  fieldName,
  label,
  value = "",
  error,
  disabled = false,
  onChange,
  onBlur,
  gridProps = { md: 4, sm: 12, xs: 12 },
  ...rest
}) => {
  return (
    <Grid item {...gridProps}>
      <InputMask
        mask="99-99-9999"
        value={value || ""}
        maskChar={null}
        disabled={disabled}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e?.target?.value, fieldName)}
        onBlur={(e: React.FocusEvent<HTMLInputElement>) => onBlur(fieldName, e?.target?.value)}
      >
        {() => (
          <TextField
            label={label}
            size="small"
            fullWidth
            placeholder="DD-MM-YYYY"
            variant="filled"
            name={fieldName}
            error={Boolean(error)}
            helperText={error ?? undefined}
            InputLabelProps={{
              shrink: true,
            }}
            {...rest} // spread all other props into TextField
          />
        )}
      </InputMask>
    </Grid>
  );
};

export default FormDateInput;
